(() => {
  const normalize = (value) => value.normalize('NFKD').toLowerCase().replace(/[^a-z0-9]+/g, ' ').trim();
  const init = (scope = document) => {
    scope.querySelectorAll('[data-coa-library]').forEach((library) => {
      if (library.dataset.initialized) return;
      library.dataset.initialized = 'true';
      const form = library.querySelector('[data-coa-form]');
      const product = library.querySelector('[data-coa-product]');
      const search = library.querySelector('[data-coa-search]');
      const count = library.querySelector('[data-coa-count]');
      const empty = library.querySelector('[data-coa-empty]');
      const reset = library.querySelector('[data-coa-reset]');
      const cards = [...library.querySelectorAll('[data-coa-report]')];
      const index = cards.map((card) => ({ card, text: normalize(card.dataset.search || card.textContent), handles: (card.dataset.productHandles || '').split('|').filter(Boolean) }));
      const params = new URLSearchParams(window.location.search);
      const requestedProduct = params.get('product') || '';
      const availableProduct = [...product.options].some((option) => option.value === requestedProduct);
      if (availableProduct) product.value = requestedProduct;
      search.value = params.get('q') || '';
      const apply = (updateUrl = false) => {
        const words = normalize(search.value).split(' ').filter(Boolean);
        let visible = 0;
        index.forEach(({ card, text, handles }) => {
          const match = (!product.value || handles.includes(product.value)) && words.every((word) => text.includes(word));
          card.hidden = !match;
          if (match) visible += 1;
        });
        count.textContent = `${visible} ${visible === 1 ? 'report' : 'reports'}${product.value || search.value.trim() ? ' matching your search' : ' in the library'}`;
        empty.hidden = visible !== 0;
        reset.hidden = !product.value && !search.value.trim();
        if (updateUrl) {
          const url = new URL(window.location.href);
          product.value ? url.searchParams.set('product', product.value) : url.searchParams.delete('product');
          search.value.trim() ? url.searchParams.set('q', search.value.trim()) : url.searchParams.delete('q');
          window.history.replaceState({}, '', url);
        }
      };
      form.addEventListener('submit', (event) => { event.preventDefault(); apply(true); });
      search.addEventListener('input', () => apply());
      product.addEventListener('change', () => apply(true));
      reset.addEventListener('click', () => { product.value = ''; search.value = ''; apply(true); search.focus(); });
      apply();
    });
  };
  init();
  document.addEventListener('shopify:section:load', (event) => init(event.target));
})();
